export default function useBranch() {
  return useNuxtApp().$branch;
}